/* eslint-disable no-console */
import { UserSettings } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import UserSettingsDelegate from "../userSettings/UserSettingsDelegate.js";
import SharedUserSettings from "../config/SharedUserSettings.js";
const {
  t
} = I18N.ns('molten.startup.plugins.ApiUserSettings');
/**
 * OnLogged, this will load blueprints, networks*, roles, and enums into redux
 * 
 * * TBD
 */

export default {
  id: 'openApi.UserSettings',
  sort: -100,
  createProvider: async (molten, ...children) => {
    const del = new UserSettingsDelegate({});
    await del.init({
      store: molten.get('store'),
      sharedValues: SharedUserSettings
    });
    UserSettings.setDelegate(del);
    return children;
  }
};